import { getFloat } from '../../../utils';
var arredondarMoeda = function (valor) { return Math.round((valor + Number.EPSILON) * 100) / 100; };
var getValorNumerico = function (valor) {
    if (typeof valor === 'number') {
        return Number.isFinite(valor) ? valor : 0;
    }
    if (typeof valor === 'string') {
        return getFloat(valor) || 0;
    }
    return 0;
};
export var calcularTotaisFolhaMensal = function (row, lancamentosOverride) {
    var lancamentos = lancamentosOverride !== null && lancamentosOverride !== void 0 ? lancamentosOverride : row === null || row === void 0 ? void 0 : row.lancamentos;
    if (!lancamentos) {
        return {
            proventos: arredondarMoeda(getValorNumerico(row === null || row === void 0 ? void 0 : row.proventos)),
            descontos: arredondarMoeda(getValorNumerico(row === null || row === void 0 ? void 0 : row.descontos)),
            taxas: arredondarMoeda(getValorNumerico(row === null || row === void 0 ? void 0 : row.taxas)),
            liquido: arredondarMoeda(getValorNumerico(row === null || row === void 0 ? void 0 : row.liquido)),
        };
    }
    var totalProventos = 0;
    var totalDescontos = 0;
    lancamentos.forEach(function (lancamento) {
        if ((lancamento === null || lancamento === void 0 ? void 0 : lancamento.informativo) === true) {
            return;
        }
        var valorNumerico = getValorNumerico(lancamento === null || lancamento === void 0 ? void 0 : lancamento.valor);
        if ((lancamento === null || lancamento === void 0 ? void 0 : lancamento.tipo) === 'DESCONTO') {
            totalDescontos += valorNumerico;
        }
        else if ((lancamento === null || lancamento === void 0 ? void 0 : lancamento.tipo) === 'PROVENTO') {
            totalProventos += valorNumerico;
        }
    });
    var taxasCorretas = getValorNumerico(row === null || row === void 0 ? void 0 : row.taxas);
    return {
        proventos: arredondarMoeda(totalProventos),
        descontos: arredondarMoeda(totalDescontos),
        taxas: arredondarMoeda(taxasCorretas),
        liquido: arredondarMoeda(totalProventos - totalDescontos),
    };
};
